<template>
  <b-card :no-body="true">
    <div slot="header">
      <b-row>
        <b-col class="col-12 col-md-6 d-flex align-items-center">
          <div>
            <strong>
              {{ $lang.audiunce_info }} ({{ audience.full_name }} )
            </strong>
          </div>
        </b-col>
        <b-col class="col-12 col-md-6">
          <div class="float-right">
            <!-- header-filter -->
            <div class="flex-end">
              <div>
                <b-button
                  @click="handleOpenParvandehReportsListPin"
                  variant="primary"
                >
                  {{ $lang.reportList }}
                </b-button>
                <ParvandehReportsListPin
                  :visible="isParvandehReportsListPin"
                  :code="audience.parvandehCode"
                  :saltFileName="audience.parvandehNumber"
                  :title="$lang.reportList"
                  @close="handleCloseParvandehReportsListPin"
                />
              </div>

              <b-button
                @click="isCollapsed = !isCollapsed"
                :class="isCollapsed ? 'btn-success ml-2' : 'btn-lightgray ml-2'"
              >
                <i
                  :class="isCollapsed ? 'fa fa-angle-up' : 'fa fa-angle-down'"
                ></i>
              </b-button>
            </div>
          </div>
        </b-col>
      </b-row>
    </div>
    <b-overlay :show="isOverlay" rounded="sm" :opacity="0.2">
      <b-collapse
        v-if="Object.keys(audience).length > 0"
        id="collapseSearchTable"
        :visible="isCollapsed"
        class="my-2"
      >
        <b-row>
          <b-col
            cols="12"
            md="4"
            class="text-center d-flex justify-content-center align-content-center"
          >
            <div class="image-person">
              <b-img
                :src="img_kind"
                class="w-100"
                rounded="circle"
                @error="errorImg"
              />
            </div>
          </b-col>
          <b-col cols="12" md="8">
            <b-col cols="12" class="py-1"
              >{{ $lang.name }} {{ $lang.family }}: {{ audience.full_name }}
            </b-col>
            <b-col v-if="audience.birth_date" cols="12" class="py-1"
              >{{ $lang.year_birth }} :
              {{ audience.birth_date && audience.birth_date.jalali }}</b-col
            >
            <b-col cols="12" class="py-1"
              >{{ $lang.marriage }} :
              {{ audience.marriage && audience.marriage.caption }}
            </b-col>
            <b-col v-if="audience.religion" cols="12" class="py-1"
              >{{ $lang.religion }}:
              {{ audience.religion && audience.religion.caption }}
            </b-col>
            <b-col v-if="audience.allegiance" cols="12" class="py-1"
              >{{ $lang.allegiance }} : {{ audience.allegiance }}
            </b-col>

            <b-col v-if="audience.national_code" cols="12" class="py-1"
              >{{ $lang.national_code }} : {{ audience.national_code }}
            </b-col>

            <b-col v-if="audience.full_path" cols="12" class="py-1">
              {{ $lang.city_address }}: {{ audience.full_path }}</b-col
            >
            <b-col v-if="audience.biography" cols="12" class="py-1"
              >{{ $lang.biography }} : {{ audience.biography }}
            </b-col>
            <b-col v-if="audience.person_license" cols="12" class="py-1">
              {{ $lang.licenses }} :
              <b-badge class="mr-2" variant="primary">
                {{ audience.person_license }}
              </b-badge>
            </b-col>
            <b-col
              v-if="audience.audience_presence_confirmation_date"
              cols="12"
              class="py-1"
            >
              {{ $lang.audience_presence_confirmation_date }} :
              <b-badge class="mr-2" variant="primary">
                {{
                  audience.audience_presence_confirmation_date &&
                  audience.audience_presence_confirmation_date.jalali
                }}
              </b-badge>
            </b-col>
          </b-col>
        </b-row>
      </b-collapse>
    </b-overlay>
  </b-card>
</template>

<script>
import ParvandehReportsListPin from "@/components/re-design/parvandeh-reports-list/ParvandehReportsListPin.vue";
import { pathOr } from "ramda";

export default {
  components: { ParvandehReportsListPin },
  props: {
    audience: {
      type: Object,
      default: () => {},
    },
    img_kind: {
      type: String,
    },
  },
  data() {
    return {
      isCollapsed: false,
      isOverlay: false,
      isParvandehReportsListPin: false,
    };
  },
  methods: {
    pathOr,
    errorImg(e) {
      if (e.type == "error") {
        e.target.src = this.$config.images.shared.noPerson;
      }
    },

    handleOpenParvandehReportsListPin() {
      this.isParvandehReportsListPin = true;
    },
    handleCloseParvandehReportsListPin() {
      this.isParvandehReportsListPin = false;
    },
  },
};
</script>

<style>
.image-person {
  width: 150px;
  display: block;
  margin: auto;
}
</style>
